module.exports = __webpack_public_path__ + "assets/img/num-02-2bb3aa61.png";